import React, { memo, useEffect, useState, useMemo } from 'react';
import { t } from 'ttag';

function Flagship() {
  const [storeSlug, setStoreSlug] = useState({});

  const languageCode = useMemo(() => window?.config?.language_code || 'en', []);

  useEffect(() => {
    const getStoreSlug = async () => {
      const apiUrl = `/api/content/pages/?type=content.StorePage&locale=${languageCode?.toLowerCase?.()}&fields=_,slug,title&limit=1`;

      const response = await fetch(apiUrl);

      if (!response.ok) {
        return;
      }

      const data = await response.json();

      setStoreSlug({
        slug: `/${data?.items?.[0]?.meta?.slug}/`,
        title: data?.items?.[0]?.title
      });
    };

    getStoreSlug();
  }, []);

  return (
    <a
      href={storeSlug?.slug || '#'}
      className="block p-1 text-black outline-none hover:underline focus:outline-none"
    >
      <span className="text-base">{storeSlug.title || t`Find Stores`}</span>
    </a>
  );
}

export default memo(Flagship);
